import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vant from 'vant';
import 'vant/lib/index.css'
import scroll from 'vue-seamless-scroll'
import common from '../src/utils/common'
import auth from '../src/utils/auth'
import { Lazyload } from 'vant';
import './assets/style/main.css'

import "amfe-flexible"
import './utils/rem'
//引入store
import store from './store'
import VueTouch from "vue-touch";
import '@vant/touch-emulator';
import Vconsole from 'vconsole'


// 移动端网页调试工具
let userdata = JSON.parse(localStorage.getItem("data"));
let phoneNumber = ''
if (userdata) {
  phoneNumber = userdata.phoneNumber
}
if (phoneNumber == '13667483747') {
  new Vconsole()
}

Vue.prototype.$common = common;
Vue.prototype.$auth = auth;
Vue.use(scroll)
Vue.use(vant);
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.use(VueTouch, { name: "v-touch" });
VueTouch.config.swipe = {
  threshold: 50  //设置左右滑动的距离
}
// 节流自定义指令
Vue.directive('throttle', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      el.style.pointerEvents = 'none'
      if (!el.disabled) {
        setTimeout(() => {
          el.style.pointerEvents = 'auto'
        }, binding.value || 300)
      }
    })
  }
})
// 防抖自定义指令
Vue.directive(
  'shake', {
  inserted: function (el, binding) {
    let timer;
    el.addEventListener("click", () => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        binding.value();
      }, 1000);
    });
  },
})

// 定义全局过滤器
Vue.filter('twoDecimals', function (value) {
  if (typeof value !== 'number') {
    return value;
  }
  return value.toFixed(2);
});

new Vue({
  router,
  store,
  render: h => h(App),
  // 安装全局事件总线，$bus就是当前应用的vm
  beforeCreate() {
    Vue.prototype.$bus = this
  }
}).$mount('#app')
